import { getOneId } from '~/utils/utils';

function getLoginStatus (): string {
  return getOneId() !== null ? 'logged-in' : 'not-logged-in';
}

export const useAdTargetingFrontpage = () => {
  if (import.meta.client && window?.googletag?.cmd) {
    window.googletag.cmd.push(function () {
      const {
        appEnv,
        ad: { pubName, targetPrefix }
      } = useRuntimeConfig().public;
      const envKey = pubName === 'dn' ? 'mode' : 'ads_env';
      const loginKey = pubName === 'dn' ? 'dn_loginstatus' : 'user_login';
      const loginValue = pubName === 'dn' ? getLoginStatus() : `${getOneId() !== null}`;
      const sectionValue = pubName === 'dn' ? 'forsiden' : 'ece_frontpage';

      window.googletag.pubads().setTargeting(envKey, appEnv);
      window.googletag.pubads().setTargeting(loginKey, loginValue);
      window.googletag.pubads().setTargeting(`${targetPrefix}_section`, sectionValue);
      window.googletag.pubads().setTargeting('cpp', 'true');
      window.googletag.pubads().setTargeting('dn_testads', `${getTestAdStatus()}`);

      const screenWidthTargetRange = getScreenWidthTargetRange();
      if (screenWidthTargetRange) {
        window.googletag.pubads().setTargeting('screen_width_range', screenWidthTargetRange);
      }
    });
  }
};
